import React from 'react';
import { TruckIcon } from 'lucide-react';
import { hostedFor, pendingFor, photoAssets, altFor, type AssetRole } from '../../data/assets';
import { brand } from '../../data/siteConfig';
interface BrandPhotoProps {
  role: AssetRole;
  /** Other slots to borrow from if this one has no hosted photo yet. */
  fallbackRoles?: AssetRole[];
  /** Used only for the placeholder; real photos use their own observed description. */
  alt: string;
  className?: string;
  icon?: React.ReactNode;
  /** Above-the-fold image: load eagerly. */
  priority?: boolean;
  /** Pin a specific file (falls back to the role if that file isn't hosted). */
  file?: string;
}

/** Renders the owner's real uploaded photo for a slot, or a neutral branded placeholder tagged with the pending filename. */
export function BrandPhoto({
  role,
  fallbackRoles,
  alt,
  className = '',
  icon,
  priority,
  file
}: BrandPhotoProps) {
  const pinned = file ? photoAssets.find(a => a.file === file && a.url) : undefined;
  const asset = pinned ?? hostedFor(role, fallbackRoles);
  if (asset?.url) {
    return <img src={asset.url} alt={alt === '' ? '' : altFor(asset, alt)} width={asset.w} height={asset.h} loading={priority ? 'eager' : 'lazy'} decoding="async" style={{
      objectPosition: asset.focus ?? 'center'
    }} className={`bg-ink-100 object-cover ${className}`} data-id="element-421" data-mp="2o4l2klcz3wu6" />;
  }
  return <div role="img" aria-label={alt} data-asset-pending={pendingFor(role)} className={`flex flex-col items-center justify-center gap-2 bg-ink-100 text-ink-300 ${className}`} data-id="element-422" data-mp="215pyuxssb2sp">
      {icon ?? <TruckIcon className="h-10 w-10" strokeWidth={1.5} aria-hidden="true" data-id="element-423" data-mp="2a3s4jqngqjmb" />}
      <span className="font-display text-xs font-extrabold tracking-wide text-ink-400" data-id="element-424" data-mp="2f4fxihv95aj6">
        {brand.name}
      </span>
    </div>;
}